export default __webpack_public_path__ + "static/media/imageContentTwo.f949ecc9.png";